export default __webpack_public_path__ + "static/media/Cloak of the Garrison.6e65b219.jpg";